export const PREVIOUS_THRESHOULD = 90
